import { Minus, Plus } from "@assets";
import { Row } from "@components/Flex";
import { Title4 } from "@components/Typography";
import { Flow } from "@ctypes";
import { useGoalFlow, useProjectedChart } from "@hooks";
import { Translations, i18n } from "@i18n";
import { useStyles } from "./styles";

export const TargetYearAdjuster = () => {
  const styles = useStyles();

  const {
    goalProps: { flow },
  } = useGoalFlow();

  const isAcceptGoalFlow = flow === Flow.AcceptSharedGoal;

  const { targetYear, projectedAge, setProjectedAge } = useProjectedChart();

  const increment = () => {
    if (projectedAge < 100) {
      setProjectedAge(projectedAge + 1);
    }
  };

  const decrement = () => {
    if (projectedAge > 0) {
      setProjectedAge(projectedAge - 1);
    }
  };

  return (
    <Row style={styles.container}>
      <Title4>{i18n.t(Translations.GoalDepositRouteTargetGoalDate)}</Title4>
      <Row style={styles.adjuster}>
        {!isAcceptGoalFlow && (
          <div onClick={decrement}>
            <Minus />
          </div>
        )}
        <Title4 style={styles.year}>{targetYear}</Title4>
        {!isAcceptGoalFlow && (
          <div onClick={increment}>
            <Plus />
          </div>
        )}
      </Row>
    </Row>
  );
};
